import { GetterTree } from 'vuex'
import { IRootState, IAuthState } from '@/@types'

const getters: GetterTree<IAuthState, IRootState> = {
  userProfile: state => {
    return state?.userProfile ?? null
  },
  isAuthenticated: state => {
    return state?.isAuthenticated ?? false
  },
  getUserLeadAlias: state => {
    return state?.userLeadAlias ?? null
  },
}

export default getters
